// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/faq.scss
// module id = 423
// module chunks = 2